const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/inkjet-elements`,
    saveDiscountTable: `${API_URL}/inkjet-element/save-discount-table`
};

export default apiUrls;
